module.exports = __webpack_public_path__ + "static/media/logo.b7404bc9.png";